import { call, put, all, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { showMessage } from 'app/store/actions/fuse';
import * as Actions from '../../actions';

function* fetchCriteria(action) {
	let criteria = action.payload;

	if (criteria) {
		try {
			yield put(Actions.fetchCriteriaInProgress(true));
			const response = yield call(() =>
				axios.get(`api/v1/histories`, {
					params: {
						q: btoa(JSON.stringify(criteria))
					}
				})
			);
			yield put(
				Actions.fetchCriteriaSuccess({
					data: response.data.data,
					pagination: response.data.pagination,
					criteria: criteria
				})
			);
		} catch (error) {
			yield put(
				showMessage({
					message: 'Unable to Retrieve Criteria ' + error,
					variant: 'error'
				})
			);
			yield put(Actions.fetchClientFailure());
		} finally {
			yield put(Actions.fetchCriteriaInProgress(false));
		}
	}
}

function* watchCriteria() {
	yield all([takeLatest(Actions.fetchCriteria, fetchCriteria)]);
}

export default watchCriteria;
